import React from 'react'
import {Stack} from '@mui/material'
import BoxAtom from '../@atoms/to_layout/box/box.atom'
import ButtonAtom from '../@atoms/to_forms/button/button.atom'
import SwitchThemeAtom from '../@atoms/to_forms/switch_theme/switch_theme.atom'
import TypographyAtom from '../@atoms/to_content/typography/typography.atom'
import ContentHeaderAtom from '../@atoms/to_content/content_header/content_header.atom'
import ListItemAtom from '../@atoms/to_content/list/list_item.atom'
import ListAtom from '../@atoms/to_content/list/list.atom'
import DeliverySectionContainer from '../@c_containers/delivery_section/delivery_section.container'
import StackAtom from '../@atoms/to_layout/stack/stack.atom'
import ColorSwatchesAtom from '../@atoms/to_content/color_swatches/color_swatches.atom'
import TextfieldAtom from '../@atoms/to_forms/textfield/textfield.atom'
import SvgIconAtom from '../@atoms/to_content/svg_icon/svg_icon.atom'
import CheckboxAtom from '../@atoms/to_forms/checkbox/checkbox.atom'
import CheckboxLabelAtom from '../@atoms/to_forms/checkbox_w_label/checkbox_w_label.atom'
import RadioGroupAtom from '../@atoms/to_forms/radio_group/radio_group.atom'
import IconButtonAtom from '../@atoms/to_forms/icon_button/icon_button.atom'
import ButtonDateTimeslotAtom from '../@atoms/to_forms/button_date_timeslot/button_date_timeslot_atom'
import ButtonTimeslotAtom from '../@atoms/to_forms/button_timeslot/button_timeslot_atom'
import ButtonPrevnextAtom from '../@atoms/to_forms/button_prevnext/button_prevnext.atom'
import ProductListItemAtom from '../@atoms/to_content/product_list/productlist_item.atom'
import ProductSofa from '../assets/images/productSofa.jpg'
import ButtonCalendarAtom from '../@atoms/to_forms/button_calendar/button_calendar.atom'
import AddressAtom from '../@atoms/to_content/address/address.atom'
import MapAtom from '../@atoms/to_content/map/map.atom'
import ProgressBarAtom from '../@atoms/to_forms/progressbar/progressbar.atom'
import DateSelectionFormComponent from '../@b_components/date_selection_form/date_selection_form.component'
import FormAtom from '../@atoms/to_forms/form/form.atom'
import CardDeliveryDetailAtom from '../@atoms/to_content/card_delivery_detail/card_delivery_detail.atom'
import DateTimeChoiceComponent from '../@b_components/date_time_choice/date_time_choice.component'
import EmailAtom from '../@atoms/to_forms/email_field/email_field.atom'
import PhoneNumberAtom from '../@atoms/to_forms/phone_number/phone_number.atom'
import DemoModalAtom from '../@atoms/to_layout/demo_modal/demo_modal.atom'
import HereMapsComponent from '../@b_components/here_maps/here_maps.component'
import bestDateData from '../data/schema/best_dates.json'
import ButtonNotifyPrefsAtom from '../@atoms/to_forms/button_notify_prefs/button_notify_prefs.atom'

const DemoStyledPage = function () {
  return (
    <>
      <TypographyAtom ap_type="h5">Atoms Demo: </TypographyAtom>
      <ContentHeaderAtom>Theme Color Swatches from our UX</ContentHeaderAtom>
      <ColorSwatchesAtom />
      <ContentHeaderAtom>Switch</ContentHeaderAtom>
      <SwitchThemeAtom />
      <ContentHeaderAtom>Icons</ContentHeaderAtom>
      <StackAtom ap_type="row">
        <div>
          <SvgIconAtom
            ap_type="arrowBack"
            ap_color="inherit"
            width="24"
            height="24"
          />
        </div>
        <div>
          <SvgIconAtom
            ap_type="bullet"
            ap_color="inherit"
            width="24"
            height="24"
          />
        </div>
        <div>
          <SvgIconAtom
            ap_type="cardCheckSelected"
            ap_color="inherit"
            width="24"
            height="24"
          />
        </div>
        <div>
          <SvgIconAtom
            ap_type="cardCheckUnselected"
            ap_color="inherit"
            width="24"
            height="24"
          />
        </div>
        <div>
          <SvgIconAtom
            ap_type="checkSelected"
            ap_color="inherit"
            width="24"
            height="24"
          />
        </div>
        <div>
          <SvgIconAtom
            ap_type="checkUnselected"
            ap_color="inherit"
            width="24"
            height="24"
          />
        </div>
        <div>
          <SvgIconAtom
            ap_type="edit"
            ap_color="inherit"
            width="24"
            height="24"
          />
        </div>
        <div>
          <SvgIconAtom
            ap_type="expandMore"
            ap_color="inherit"
            width="24"
            height="24"
          />
        </div>
        <div>
          <SvgIconAtom
            ap_type="greenLeaf"
            ap_color="inherit"
            width="24"
            height="24"
          />
        </div>
        <div>
          <SvgIconAtom
            ap_type="navigateNext"
            ap_color="inherit"
            height="24"
            width="24"
          />
        </div>
        <div>
          <SvgIconAtom
            ap_type="navigatePrevious"
            ap_color="inherit"
            height="24"
            width="24"
          />
        </div>
        <div>
          <SvgIconAtom
            ap_type="package"
            ap_color="inherit"
            width="24"
            height="24"
          />
        </div>
      </StackAtom>
      <ContentHeaderAtom>Buttons</ContentHeaderAtom>
      <Stack spacing={2} direction="row">
        <ButtonAtom ap_type="primary">Primary</ButtonAtom>
        <ButtonAtom ap_type="secondary">Secondary</ButtonAtom>
        <ButtonAtom ap_type="primary" disabled>
          Pri-disabled
        </ButtonAtom>
        <ButtonAtom ap_type="secondary" disabled>
          Sec-disabled
        </ButtonAtom>
      </Stack>
      <ContentHeaderAtom>Date and time Choice</ContentHeaderAtom>
      <DateTimeChoiceComponent />
      <ContentHeaderAtom>Button Calendar Atom</ContentHeaderAtom>
      <BoxAtom maxWidth="347px">
        <ButtonCalendarAtom
          ap_calen_arr={[
            {
              ap_type: 'disabled',
              ap_day_short: 'sun',
              ap_day: 1,
              ap_date: '1/02/2021',
            },
            {
              ap_type: 'echo',
              ap_day_short: 'mon',
              ap_day: 2,
              ap_date: '2/02/2021',
            },
            {
              ap_type: 'echo',
              ap_day_short: 'tue',
              ap_day: 3,
              ap_date: '3/02/2021',
            },
            {
              ap_type: 'selectable',
              ap_day_short: 'wed',
              ap_day: 4,
              ap_date: '4/02/2021',
            },
            {
              ap_type: 'disabled',
              ap_day_short: 'thu',
              ap_day: 5,
              ap_date: '5/02/2021',
            },
            {
              ap_type: 'selectable',
              ap_day_short: 'fri',
              ap_day: 6,
              ap_date: '6/02/2021',
            },
            {
              ap_type: 'selectable',
              ap_day_short: 'sat',
              ap_day: 7,
              ap_date: '7/02/2021',
            },
          ]}
        />
      </BoxAtom>

      <ContentHeaderAtom>Date and Timeslot Selection</ContentHeaderAtom>
      <ButtonDateTimeslotAtom ap_data_arr={bestDateData} />
      <ContentHeaderAtom>Timeslot Selection</ContentHeaderAtom>
      <ButtonTimeslotAtom ap_data_arr={bestDateData} />
      <ContentHeaderAtom>Date selection form </ContentHeaderAtom>
      <DateSelectionFormComponent />
      <ContentHeaderAtom>Address</ContentHeaderAtom>
      <AddressAtom
        ap_data_arr={[
          {
            clientName: 'Joshua Crisp',
            addressLine1: '123 Anywhere Street',
            addressLine2: 'Mytown',
            CountryName: 'GA',
            PostalCode: '12345-1234',
          },
        ]}
      />
      <ContentHeaderAtom>Map</ContentHeaderAtom>
      <MapAtom ap_latitude={10.1572477} ap_longitude={76.3909298} zoom={12} />

      <ContentHeaderAtom>Here Maps - london</ContentHeaderAtom>
      <HereMapsComponent ap_latitude={51.509865} ap_longitude={-0.118092} />

      <ContentHeaderAtom>Progress bar</ContentHeaderAtom>
      <ProgressBarAtom
        ap_progress_status_arr={[
          'Ordered',
          'Booked',
          'Confirmed',
          'Out for Delivery',
          'Delivered',
        ]}
        ap_progress_step={2}
      />
      <ContentHeaderAtom>Buttons for Navigation</ContentHeaderAtom>
      <BoxAtom display="flex" gap="24px">
        <ButtonPrevnextAtom disableRipple ap_type="prev" />
        <ButtonPrevnextAtom disableRipple ap_type="next" />
      </BoxAtom>
      <ContentHeaderAtom>Icon Buttons</ContentHeaderAtom>
      <StackAtom ap_type="row">
        <div className="flex">
          <IconButtonAtom ap_type="edit" />
        </div>
        <div className="flex">
          <IconButtonAtom ap_type="arrowBack" />
        </div>
      </StackAtom>
      <ContentHeaderAtom>Radio</ContentHeaderAtom>
      <StackAtom ap_type="row">
        <div>
          <RadioGroupAtom
            row
            label="Select City"
            valueDefault="Delhi"
            valuesArr={['London', 'Delhi', 'New York']}
          />
        </div>
      </StackAtom>
      <ContentHeaderAtom>Checkbox Buttons</ContentHeaderAtom>
      <CheckboxLabelAtom
        control={<CheckboxAtom checked />}
        label="Enabled Selected"
        labelPlacement="bottom"
      />
      <CheckboxLabelAtom
        control={<CheckboxAtom />}
        label="Enabled Deselected"
        labelPlacement="bottom"
      />
      <CheckboxLabelAtom
        control={<CheckboxAtom disabled checked />}
        label="Disabled Selected"
        labelPlacement="bottom"
      />
      <CheckboxLabelAtom
        control={<CheckboxAtom disabled />}
        label="Disabled Deselected"
        labelPlacement="bottom"
      />
      <ContentHeaderAtom>Textfields</ContentHeaderAtom>
      {/* <StackAtom ap_type="row"> */}
      <div>
        <TypographyAtom ap_type="label2">Inactive field</TypographyAtom>
        <TextfieldAtom
          label="Enter your First Name"
          helperText="Assistive Text"
        />
      </div>
      <div>
        <TypographyAtom ap_type="label2">Disabled field</TypographyAtom>
        <TextfieldAtom label="Textfield disabled" disabled />
      </div>
      <div>
        <TypographyAtom ap_type="label2">Activated</TypographyAtom>
        <TextfieldAtom
          label="Textfield"
          value="Activated Textfield"
          helperText="Assistive Text"
        />
      </div>
      <div>
        <TypographyAtom ap_type="label2">Focus</TypographyAtom>
        <TextfieldAtom
          label="Textfield"
          focused
          value="Focused Textfield"
          helperText="Assistive Text"
        />
      </div>
      <div>
        <TypographyAtom ap_type="label2">Error</TypographyAtom>
        <TextfieldAtom
          label="Error"
          value="Error Text"
          error
          helperText="Error"
        />
      </div>
      {/* </StackAtom> */}
      <ContentHeaderAtom>Content</ContentHeaderAtom>
      <DeliverySectionContainer />
      <ContentHeaderAtom>
        Typography HDX - Total: 26types. (<code>ex: ahd_type=`calDate`</code>)
      </ContentHeaderAtom>
      <StackAtom ap_type="row">
        <TypographyAtom ahd_type="currentStep">
          currentStep Typography
        </TypographyAtom>
        <TypographyAtom ahd_type="calDate">calDate Typography</TypographyAtom>
        <TypographyAtom ahd_type="calDateD">calDateD Typography</TypographyAtom>
        <div>
          <TypographyAtom ahd_type="calDateS">
            calDateS Typography
          </TypographyAtom>
        </div>
        <TypographyAtom ahd_type="fData">fData Typography</TypographyAtom>
        <TypographyAtom ahd_type="formLabel">
          formLabel Typography
        </TypographyAtom>
        <div>
          <TypographyAtom ahd_type="navLink">navLink Typography</TypographyAtom>
        </div>
        <div>
          <TypographyAtom ahd_type="pButton">pButton Typography</TypographyAtom>
        </div>
        <TypographyAtom ahd_type="h7">h7 Typography</TypographyAtom>
        <TypographyAtom ahd_type="h6">h6 Typography</TypographyAtom>
        <TypographyAtom ahd_type="popHeader">
          popHeader Typography
        </TypographyAtom>
        <TypographyAtom ahd_type="regText">regText Typography</TypographyAtom>
        <div>
          <TypographyAtom ahd_type="sButton">sButton Typography</TypographyAtom>
        </div>
        <TypographyAtom ahd_type="sData">sData Typography</TypographyAtom>
        <TypographyAtom ahd_type="sLabel">sLabel Typography</TypographyAtom>
        <TypographyAtom ahd_type="sLink">sLink Typography</TypographyAtom>
        <TypographyAtom ahd_type="mLink">mLink Typography</TypographyAtom>
        <TypographyAtom ahd_type="selectableDate">
          selectableDate Typography
        </TypographyAtom>
        <TypographyAtom ahd_type="selectableTime">
          selectableTime Typography
        </TypographyAtom>
        <TypographyAtom ahd_type="product">product Typography</TypographyAtom>
        <TypographyAtom ahd_type="subheading">
          subheading Typography
        </TypographyAtom>
        <TypographyAtom ahd_type="status">status Typography</TypographyAtom>
        <TypographyAtom ahd_type="step">step Typography</TypographyAtom>
        <TypographyAtom ahd_type="uid">uid Typography</TypographyAtom>
      </StackAtom>
      <ContentHeaderAtom>
        Typography Aptean - Total: 13 types (<code>ex: ap_type=`title`</code>)
      </ContentHeaderAtom>
      <StackAtom ap_type="row">
        <TypographyAtom ap_type="h1">h1 Typography</TypographyAtom>
        <TypographyAtom ap_type="h2">h2 Typography</TypographyAtom>
        <TypographyAtom ap_type="h3">h3 Typography</TypographyAtom>
        <TypographyAtom ap_type="h4">h4 Typography</TypographyAtom>
        <TypographyAtom ap_type="h5">h5 Typography</TypographyAtom>
        <TypographyAtom ap_type="h6">h6 Typography</TypographyAtom>
        <TypographyAtom ap_type="title">title Typography</TypographyAtom>
        <TypographyAtom ap_type="subtitle">subtitle Typography</TypographyAtom>
        <TypographyAtom ap_type="label1">label1 Typography</TypographyAtom>
        <TypographyAtom ap_type="label2">label2 Typography</TypographyAtom>
        <TypographyAtom ap_type="body">body Typography</TypographyAtom>
        <TypographyAtom ap_type="body2">body2 Typography</TypographyAtom>
        <TypographyAtom ap_type="button">button Typography</TypographyAtom>
      </StackAtom>
      <ContentHeaderAtom>Product List</ContentHeaderAtom>
      <ListAtom>
        <ListItemAtom />
        <ListItemAtom />
        <ListItemAtom />
      </ListAtom>
      <ContentHeaderAtom>Product List Items</ContentHeaderAtom>
      <ListAtom>
        <ProductListItemAtom
          ap_type="productImage"
          ap_product_image={ProductSofa}
        />
        <ProductListItemAtom ap_type="productImageNull" />
        <ProductListItemAtom ap_type="packageIcon" />
      </ListAtom>
      <ContentHeaderAtom>Visit Lozenge Card</ContentHeaderAtom>
      <CardDeliveryDetailAtom
        ap_visit_val="01234567891"
        ap_arrival_date="May 21"
        ap_arrival_time="10am - 2pm"
        ap_delivery_details="Lorem ipsum dolor sit amet, consetetur sadipscing
elitr, sed diam nonumy eirmod tempor invidunt ut
labore et dolore magna aliquyam erat, sed diam
voluptua. At vero eos et accusam et justo duo
dolores et ea rebum. Stet clita kasd gubergren, no
sea takimata sanctus est Lorem ipsum dolor sit
amet. Lorem ipsum dolor sit amet, consetetur
sadipscing elitr, sed diam nonumy eirmod tempor
invidunt ut labore et dolore magna aliquyam erat,
sed diam voluptua. At vero eos et accusam et
justo duo dolores et ea rebum. Stet clita kasd
gubergren, no sea takimata sanctus est Lorem"
        ap_progress_status_arr={[
          'Ordered',
          'Booked',
          'Confirmed',
          'Out for Delivery',
          'Delivered',
        ]}
        ap_progress_step={1}
      />
      <ContentHeaderAtom>Modal Windows - Desktop/Mobile</ContentHeaderAtom>
      <DemoModalAtom>
        Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nulla aliquet,
        ligula sed tinc id unt aliquam, tortor nibh pretium risus, et semper
        magna dui sit amet ipsum. Vestibulum commodo fringilla est, et fermentum
        ligula rutrum ac. Lorem ipsum dolor sit amet, consectetur adipiscing
        elit. Nulla aliquet, ligula sed tinc id unt aliquam, tortor nibh pretium
        risus, et semper magna dui sit amet ipsum. Vestibulum commodo fringilla
        est, et fermentum ligula rutrum ac.
      </DemoModalAtom>
      <ContentHeaderAtom>Edit Notification Preferences</ContentHeaderAtom>
      <DemoModalAtom>
        <ButtonNotifyPrefsAtom />
      </DemoModalAtom>
      <ContentHeaderAtom>Form Atom with validations</ContentHeaderAtom>
      <FormAtom>
        <EmailAtom />
        <br />
        <PhoneNumberAtom />
        <br />
      </FormAtom>
      {/* <ContentHeaderAtom>Product Info Component</ContentHeaderAtom>
      <ProductInfoComponent /> */}
    </>
  )
}

export default DemoStyledPage
